import { invokeApi } from "../../bl_libs/invokeApi";

export const forgot_password_api = async (email) => {
  const requestObj = {
    path: `api/school/forgot-password`,
    method: "POST",
    headers: {},
    postData: { email },
  };
  return invokeApi(requestObj);
};

export const verify_reset_token_api = async (token) => {
  const requestObj = {
    path: `api/school/reset-password/verify`,
    method: "GET",
    headers: {},
    queryParams: { token },
  };
  return invokeApi(requestObj);
};

export const reset_password_api = async (data) => {
  const requestObj = {
    path: `api/school/reset-password`,
    method: "POST",
    headers: {},
    postData: data,
  };
  return invokeApi(requestObj);
};
